export default __webpack_public_path__ + "static/ai-consultancy-1--mobile-825514f996e83c8e71d911484523acda.png";